import { connect } from 'react-redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { CompositeSessionInfoSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { addContentFavorite, removeContentFavorite } from '~src/favorites/actions/FavoritesActions';
import { contentCountsUpToDate } from '~src/spacesPlatform/actions/ContentCountsActions';
import { populateContentBreadcrumbs } from '~src/spacesPlatform/components/breadcrumbs/BreadcrumbHelpers';
import { selectContentCounts, selectContentCountsUpToDate } from '~src/spacesPlatform/selectors/ContentCountsSelector';
import { SimulationSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

import { enterSimulationSubspace } from '../actions/EnterSimulationSubspaceAction';
import { simulationCountsRequest } from '../actions/SimulationCountsRequestAction';
import { ISimulationDetailWithUsageInfo } from '../models/ISimulationInfo';
import {
  SimulationSpace,
  SimulationSpaceDispatchProps,
  SimulationSpaceOwnProps,
  SimulationSpaceStateProps,
} from './SimulationSpace';

const mapStateToProps: MapStateToProps<SimulationSpaceStateProps> = (state) => ({
  contentCountsSimulation: selectContentCounts<'simulation'>(state, 'simulation'),
  urls: siteUrlsSelector(state),
  contentCountsUpToDate: selectContentCountsUpToDate(state),
  isServerOrSiteAdmin: CompositeSessionInfoSelectors.currentUserIsSiteOrServerAdminSelector(state),
  areUsersVisible: !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state)
});

const mapDispatchToProps: MapDispatchToProps<SimulationSpaceDispatchProps, SimulationSpaceOwnProps> = (dispatch, ownProps) => ({
  addToFavorites: () => {
    dispatch(addContentFavorite(ownProps.simulationDetailInfo));
  },
  enterSpace: (simulationDetailInfo?: ISimulationDetailWithUsageInfo) => {
    dispatch(enterSimulationSubspace(
      simulationDetailInfo ?? ownProps.simulationDetailInfo,
      ownProps.subplaceName as SimulationSubspaceName
    ));
  },
  fetchUpdatedContentCounts: () => {
    dispatch(simulationCountsRequest('simulation'));
  },
  markContentCountsUpToDate: () => {
    dispatch(contentCountsUpToDate());
  },
  removeFromFavorites: () => {
    dispatch(removeContentFavorite(ownProps.simulationDetailInfo));
  },
  populateContentBreadcrumbs,
});

export const ConnectedSimulationSpace = connect(mapStateToProps, mapDispatchToProps)(SimulationSpace);
